export default "__VITE_ASSET__qSSTtKXr__"